/** The build stamp from `vite.config.ts` (commit and date), or a placeholder outside a Vite build. */
declare const __GBR_BUILD__: string | undefined;

export const BUILD_STAMP: string = typeof __GBR_BUILD__ === 'string' ? __GBR_BUILD__ : 'development build';
